import { PathDefinition } from "../../../models/setup.interface";

export const PATHS: PathDefinition[] = [
  {
    order: 1,
    key: 'FH_PATH',
    name: "Face heart",
    description: 'Caminho: TRIAGE. FACE_HEART'
  },
  {
    order: 2,
    key: 'TELEMEDICINE_PATH',
    name: "Tele medicina",
    description: 'Caminho: TRIAGE, FACE_HEART, DR_OLIVE, TELEMEDICINE'
  },
  {
    order: 3,
    key: 'DROLIVE_PATH',
    name: "Infer médica",
    description: 'Caminho: TRIAGE, DR_OLIVE'
  },
  {
    order: 4,
    key: 'SKINCARE_PATH',
    name: "Skin care",
    description: 'Caminho: SKIN_CARE'
  },
  {
    order: 5,
    key: 'QUESTIONNAIRE_PATH',
    name: "Questionário",
    description: 'Caminho: QUESTIONNAIRE'
  }
];